module.exports = __webpack_public_path__ + "static/media/pedido-entregado-cilindro-green.4fd4a02b.svg";